import { render, staticRenderFns } from "./CatalogContent.vue?vue&type=template&id=5f8ed942&scoped=true"
import script from "./CatalogContent.vue?vue&type=script&lang=js"
export * from "./CatalogContent.vue?vue&type=script&lang=js"
import style0 from "./CatalogContent.vue?vue&type=style&index=0&id=5f8ed942&prod&lang=scss&scoped=true"
import style1 from "./CatalogContent.vue?vue&type=style&index=1&id=5f8ed942&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8ed942",
  null
  
)

export default component.exports